import { LoaderIcon } from 'lucide-react';

const LoadingSpinner = () => {
  return <LoaderIcon className="animate-spin" />;
};

export default LoadingSpinner;
